import { render } from "./mrc-mortgagerates.vue?vue&type=template&id=4b78be86"
import script from "./mrc-mortgagerates.js?vue&type=script&lang=js"
export * from "./mrc-mortgagerates.js?vue&type=script&lang=js"

import "./mrc-mortgagerates.vue?vue&type=style&index=0&id=4b78be86&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__